import {  createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store/store";

type SliceState = { value: null } 

const initialState:SliceState = {
  value: null
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    updateTenant: (state,action) => {
      state.value =action.payload;
    },
    clearTenant:(state)=>{
      state.value =null;
    }
  },
});

export const { updateTenant,clearTenant} = appSlice.actions;
export const getTenantName = (state:RootState) => state.app.value;
export default appSlice.reducer;
